module.exports = __webpack_public_path__ + "static/media/logoSaleNoti.f3d3b02c.png";